"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfTopmostShapeBoundsCalculator = void 0;
var tslib_1 = require("tslib");
var rtf_drawing_keywords_1 = require("../../../../translation-table/rtf-drawing-keywords");
var rtf_bounds_calculator_base_1 = require("./rtf-bounds-calculator-base");
var RtfTopmostShapeBoundsCalculator = (function (_super) {
    tslib_1.__extends(RtfTopmostShapeBoundsCalculator, _super);
    function RtfTopmostShapeBoundsCalculator(shapePropertiesInfo) {
        return _super.call(this, shapePropertiesInfo) || this;
    }
    Object.defineProperty(RtfTopmostShapeBoundsCalculator.prototype, "bottomKeyword", {
        get: function () {
            return rtf_drawing_keywords_1.RtfDrawingKeywords.ShapeBottom;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RtfTopmostShapeBoundsCalculator.prototype, "leftKeyword", {
        get: function () {
            return rtf_drawing_keywords_1.RtfDrawingKeywords.ShapeLeft;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RtfTopmostShapeBoundsCalculator.prototype, "rightKeyword", {
        get: function () {
            return rtf_drawing_keywords_1.RtfDrawingKeywords.ShapeRight;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RtfTopmostShapeBoundsCalculator.prototype, "topKeyword", {
        get: function () {
            return rtf_drawing_keywords_1.RtfDrawingKeywords.ShapeTop;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RtfTopmostShapeBoundsCalculator.prototype, "flipHKeyword", {
        get: function () {
            return rtf_drawing_keywords_1.RtfDrawingKeywords.FlipH;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RtfTopmostShapeBoundsCalculator.prototype, "flipVKeyword", {
        get: function () {
            return rtf_drawing_keywords_1.RtfDrawingKeywords.FlipV;
        },
        enumerable: false,
        configurable: true
    });
    RtfTopmostShapeBoundsCalculator.prototype.getPositionCore = function (value) {
        return value;
    };
    return RtfTopmostShapeBoundsCalculator;
}(rtf_bounds_calculator_base_1.RtfBoundsCalculatorBase));
exports.RtfTopmostShapeBoundsCalculator = RtfTopmostShapeBoundsCalculator;
